import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSidebar } from "@/components/ui/sidebar";

/**
 * On mobile the sidebar renders as an overlay sheet — close it whenever the
 * route changes so navigating never leaves the menu covering the page.
 */
export default function SidebarMobileAutoClose() {
  const { isMobile, openMobile, setOpenMobile } = useSidebar();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isMobile && openMobile) setOpenMobile(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
